import dayjs from 'dayjs';
import type {
  ForestMassStatus,
  STATUS_ASEFOR,
  STATUS_FINSA,
  STATUS_FORTOP,
  STATUS_UAV,
} from '@/domain/entities/ForestMassStatus';
import type {ForestMassStatusDto} from './ForestMassStatusDto';

export const toDomain = (dto: ForestMassStatusDto): ForestMassStatus => ({
  ...dto,
  fortopStatus: dto.fortopStatus as STATUS_FORTOP,
  aseforStatus: dto.aseforStatus as STATUS_ASEFOR,
  finsaStatus: dto.finsaStatus as STATUS_FINSA,
  plannedCuttingDate: dayjs(dto.plannedCuttingDate),
  createdAt: dayjs(dto.createdAt),
  finsaStatusChangeDate: dayjs(dto.finsaStatusChangeDate),
  aseforStatusChangeDate: dayjs(dto.aseforStatusChangeDate),
  fortopStatusChangeDate: dayjs(dto.fortopStatusChangeDate),
  uavMetricsStatus: dto.uavMetricsStatus ? (dto.uavMetricsStatus as STATUS_UAV) : null,
  uavMetricsStatusChangeDate: dto.uavMetricsStatusChangeDate ? dayjs(dto.uavMetricsStatusChangeDate) : null,
});
